/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FeedbackIssueType } from './';
import {
    FeedbackIssueTypeFromJSON,
    FeedbackIssueTypeFromJSONTyped,
    FeedbackIssueTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface InternalFeedbackRequest
 */
export interface InternalFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalFeedbackRequest
     */
    feedback: string;
    /**
     * 
     * @type {Array<FeedbackIssueType>}
     * @memberof InternalFeedbackRequest
     */
    issueTypes: Array<FeedbackIssueType>;
    /**
     * The page from which the feedback is sent.
     * @type {string}
     * @memberof InternalFeedbackRequest
     */
    pageOrigin: InternalFeedbackRequestPageOriginEnum;
}


/**
 * @export
 */
export const InternalFeedbackRequestPageOriginEnum = {
    SummaryPage: 'SUMMARY_PAGE',
    SelectionPage: 'SELECTION_PAGE'
} as const;
export type InternalFeedbackRequestPageOriginEnum = typeof InternalFeedbackRequestPageOriginEnum[keyof typeof InternalFeedbackRequestPageOriginEnum];


/**
 * Check if a given object implements the InternalFeedbackRequest interface.
 */
export function instanceOfInternalFeedbackRequest(value: object): value is InternalFeedbackRequest {
    if (!('feedback' in value) || value['feedback'] === undefined) return false;
    if (!('issueTypes' in value) || value['issueTypes'] === undefined) return false;
    if (!('pageOrigin' in value) || value['pageOrigin'] === undefined) return false;
    return true;
}

export function InternalFeedbackRequestFromJSON(json: any): InternalFeedbackRequest {
    return InternalFeedbackRequestFromJSONTyped(json, false);
}

export function InternalFeedbackRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalFeedbackRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'feedback': json['feedback'],
        'issueTypes': ((json['issueTypes'] as Array<any>).map(FeedbackIssueTypeFromJSON)),
        'pageOrigin': json['pageOrigin'],
    };
}

export function InternalFeedbackRequestToJSON(value?: InternalFeedbackRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'feedback': value['feedback'],
        'issueTypes': ((value['issueTypes'] as Array<any>).map((v) => FeedbackIssueTypeToJSON(v))),
        'pageOrigin': value['pageOrigin'],
    };
}

